<template>
    <div class="kgr-inputGroup kgr-inputGroup--constrainedWidth">
        <kgr-form-row
            :label="$t('Mandanten-Nummer (für Finanzbuchhaltung):')"
            :error="error"
            field-name="clientNumber"
        >
            <input
                v-model.trim="datevSettings.clientNumber"
                type="text"
                class="kgr-input"
            />
        </kgr-form-row>

        <kgr-form-row
            :label="$t('Beraternummer')"
            :error="error"
            field-name="consultantNumber"
            :tooltip="$t('Gib hier deine DATEV-Beraternummer ein. Diese erhältst du von deinem Steuerberater.')"
        >
            <input
                v-model.trim="datevSettings.consultantNumber"
                type="text"
                class="kgr-input"
            />
        </kgr-form-row>

        <kgr-form-row
            :label="$t('Monatsabschlussdatum')"
            :error="error"
            field-name="endOfMonthDate"
            :tooltip="$t('Bitte gib hier eine Zahl zwischen 1 und 31 ein.')"
        >
            <input
                v-model.trim="datevSettings.endOfMonthDate"
                type="text"
                class="kgr-input"
            />
        </kgr-form-row>

        <kgr-checkbox
            v-model="datevSettings.annualStatementPeriods"
            :label="$t('Jahresabschluss-Sonderperioden im FiBu-Übergabedialog anzeigen')"
            class="kgr-row"
        />

        <kgr-checkbox
            v-model="datevSettings.variousAccounts"
            :label="$t('Debitoren gesammelt unter Diverse Konten exportieren')"
            class="kgr-row"
        />
    </div>
</template>

<script>
import Checkbox from '../common/form/checkbox/Checkbox';
import Error from '../../js/model/Error';
import FormRow from '../common/form/FormRow';

export default {
    components: {
        'kgr-checkbox': Checkbox,
        'kgr-form-row': FormRow,
    },
    props: {
        datevSettings: {
            type: Object,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
